export default "<div>\n  <p>Contact us:</p>\n  <p>Email: mailigcshop@gmail.com</p>\n  <p>Phone: 9622761928</p>\n</div>\n"